module.exports = __webpack_public_path__ + "fonts/a0737de.ttf";